export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];

export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
